import * as React from 'react';

import { FormGroup, Input, Label } from 'reactstrap';

import { FormErrorFeedback } from 'common/components/form/FormErrorFeedback';
import { toFormGroupStyle, isFieldValid } from 'common/utils/form';
import { getCountries } from 'country-fns';
import { FormInput } from 'common/components/form/FormInput';

export interface FormAddressInputProps {
  form: any;
  label?: string;
  prefix?: string;
}

const countries = getCountries().map((country: { iso2: string; name: string }) => (
  <option value={country.iso2.toUpperCase()} key={country.iso2}>
    {country.name}
  </option>
));

export const FormAddressInput: React.SFC<FormAddressInputProps> = props => {
  const form = props.form;
  const values = props.form.values;
  const prefix = props.prefix ? props.prefix + '_' : '';
  const label = props.label ? props.label : 'Address';
  return (
    <div>
      <div className="row">
        <div className="col">
          <FormGroup color={toFormGroupStyle(prefix + 'street1', form)}>
            <Label for={prefix + 'street1'}>{label}</Label>
            <Input
              style={{ marginBottom: '.5rem' }}
              id={prefix + 'street1'}
              value={values[prefix + 'street1']}
              onChange={form.handleChange}
              onBlur={form.handleBlur}
              autoComplete="off"
              invalid={!isFieldValid(form, prefix + 'street1')}
            />
            <Input
              name={prefix + 'street2'}
              value={values[prefix + 'street2']}
              onChange={form.handleChange}
              onBlur={form.handleBlur}
              autoComplete="off"
              invalid={!isFieldValid(form, prefix + 'street2')}
            />
            <FormErrorFeedback field={prefix + 'street1'} form={form} />
          </FormGroup>
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <FormInput id={prefix + 'city'} label="City" name={prefix + 'city'} autoComplete="off" />
        </div>
        <div className="col-12">
          <FormInput id={prefix + 'state'} label="State/Province/Region" name={prefix + 'state'} autoComplete="off" />
        </div>
        <div className="col-12">
          <FormInput id={prefix + 'postal'} label="Postal" name={prefix + 'postal'} />
        </div>
        <div className="col-12">
          <FormInput id={prefix + 'country'} label="Country" name={prefix + 'country'} tag="select">
            <option value="">Select Country</option>
            <option value="US">United States</option>
            <option value="CA">Canada</option>
            {countries}
          </FormInput>
        </div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/common/components/form/FormAddressInput.tsx